export const companyKpiData = {
    data: [
        {
            title: 'Faults',
            data:  [
                {
                    value: '26',
                    label: 'Total'
                },
                {
                    value: '4',
                    label: 'High'
                },
                {
                    value: '12',
                    label: 'Medium'
                },
                {
                    value: '10',
                    label: 'Low'
                }
            ],
            information: 'These Company KPIs give an overview of Company Rules.'
        }
    ]
};
